import {computed} from "vue";
import {useRouter, useRoute} from "vue-router";
import {useStore} from "vuex";

export default function() {
  const router = useRouter()
  const route = useRoute()
  const query = route.query
  const store = useStore()

  const results = computed(() => {
    return store.state.moduleA.results;
  })

  const prevTo = () => {
    const prevRoute = router.getRoutes().find(item => {
      return item.meta["order"] === (route.meta["order"]-1)
    })
    if (route.meta["order"]-1 === 0)
      store.commit("setResults", [])

    router.push({name:prevRoute.name, query: query})
  }

  const nextTo = () => {
    const nextRoute = router.getRoutes().find(item => {
      return item.meta["order"] === (route.meta["order"] + 1)
    })
    let queryObj = {gender:query.gender}
    results.value.forEach(item => {
      Object.assign(queryObj, {[item.property]:item.val})
    })
    router.push({name:nextRoute.name, query:queryObj})
    return nextRoute
  }

  const pushTo = (where, query) => {
    router.push({name:where, query:query})
    if (where === "ModuleA")
      store.commit("setResults", [])
  }

  return {pushTo, prevTo, nextTo}
}
